import React from 'react';

import slavka from './img/stanislavaVavrinova.jpg';
import email from './img/email.svg';
import address from './img/address.svg';
import web from './img/web.svg';
import linkedin from './img/linkedin.svg';
import instagram from './img/instagram.svg';
import czechitas from './img/logoCzechitas.svg';
import gopas from './img/gopas.svg';
import netteSmall from './img/netteSmall.svg';
import github from './img/github.svg';
import coursera from './img/coursera.svg';
import google from './img/google.svg';
import wesbos from './img/wesbos.png';

const ComponentToPrint = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <div class="page">
        <div className="cv__hero">
          <img class="foto" src={slavka} alt="Stanislava Vavřinová" />
          <div class="hero__rightSide">
            <h1 className="cv__title">Ing. Stanislava Vavřinová</h1>

            <ul class="contact">
              <li class="contact__phoneEmail">
                <a className="cv__link" href="https://slavkavav.cz/">
                  <img src={web} alt="Logo web" />
                  https://slavkavav.cz/
                </a>
                <a className="cv__link" href="malito:slavka.vav@gmail.com">
                  <img src={email} alt="Email icon" />
                  slavka.vav@gmail.com
                </a>
              </li>

              <li class="contact__address">
                <div>
                  <img src={address} alt="Address icon" /> Nové Homole near
                  České Budějovice
                </div>
              </li>

              <li class="contact__socialNetworks">
                <a
                  className="cv__link"
                  href="https://www.linkedin.com/in/stanislava-vav%C5%99inov%C3%A1-b325b6204/"
                  target="_blanc"
                >
                  <img
                    class="logoSocialNetworks"
                    src={linkedin}
                    alt="Logo LinkedIn"
                  />
                  Stanislava Vavřinová
                </a>
                <a
                  className="cv__link"
                  href="https://www.instagram.com/slavkavavrinova/"
                  target="_blanc"
                >
                  <img
                    class="logoSocialNetworks"
                    src={instagram}
                    alt="Logo Instagram"
                  />
                  slavkavavrinova
                </a>
                <a
                  className="cv__link"
                  href="https://github.com/SlavkaVavrinova"
                  target="_blanc"
                >
                  <img
                    class="logoSocialNetworks"
                    src={github}
                    alt="Logo GitHub"
                  />
                  SlavkaVavrinova
                </a>
              </li>
            </ul>

            <div class="important">
              <section class="important__it">
                <h2 className="cv__h2">IT Skills</h2>
                <ul className="cv__list">
                  <li>PHP, Nette</li>
                  <li>React, Next.js</li>
                  <li>HTML/CSS</li>
                  <li>JavaScript</li>
                  <li>Microsoft SQL server</li>
                  <li>UX Design</li>
                  <li>WordPress</li>
                  <li>Bootstrap, SASS</li>
                  <li>Adobe XD, Figma, Canva, Photoshop</li>
                </ul>
              </section>
              <section class="important__portfolio">
                <h2 className="cv__h2">Portfolio</h2>
                <ul>
                  <li>
                    <a
                      className="cv__link"
                      href="https://slavkavav.cz"
                      target="_blanc"
                    >
                      https://slavkavav.cz
                    </a>
                    React
                  </li>
                  <li>
                    <a
                      className="cv__link"
                      href="https://budejcanda.cz"
                      target="_blanc"
                    >
                      https://budejcanda.cz
                    </a>
                    Next.js
                  </li>
                  <li>
                    <a
                      className="cv__link"
                      href="https://gerta.cz"
                      target="_blanc"
                    >
                      https://gerta.cz
                    </a>
                    Eleventy
                  </li>
                  <li>
                    <a
                      className="cv__link"
                      href="https://appkahyposka.cz"
                      target="_blanc"
                    >
                      https://appkahyposka.cz
                    </a>
                    React
                  </li>

                  <li>
                    <a
                      className="cv__link"
                      href="https://chatagerta.cz"
                      target="_blanc"
                    >
                      https://chatagerta.cz
                    </a>
                    WP
                  </li>
                  <li>
                    <a
                      className="cv__link"
                      href="https://chataruzenka.cz"
                      target="_blanc"
                    >
                      https://chataruzenka.cz
                    </a>
                    WP
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>

        <div className="cv__wrapper">
          <div class="container">
            <div class="container__leftSide">
              <section class="courses">
                <h2 className="cv__h2">Courses</h2>
                <ul className="cv__list">
                  <img class="logo" src={netteSmall} alt="Logo Nette" />
                  <li>Web development at Nette</li>
                  <li>Mastering Nette</li>
                </ul>

                <img class="logoGopas" src={gopas} alt="Logo Gopas" />
                <ul className="cv__list">
                  <li>Optimizing, Debugging, and Monitoring T-SQL Queries</li>
                  <li>
                    Creating Advanced T-SQL Queries in Microsoft SQL Server
                  </li>
                  <li>TypeScript</li>
                  <li>PHP Programming in Practice</li>
                  <li>Object-Oriented Programming in PHP</li>
                </ul>

                <img
                  class="logoCzechitas logoCzechitas--small"
                  src={czechitas}
                  alt="Logo Czechitas"
                />
                <ul className="cv__list">
                  <li>Digital Web Academy</li>
                  <li>Become a Coder</li>
                  <li>Advanced PHP course</li>
                  <li>Bootstrap</li>
                  <li>Wordpress 1, 2, 3</li>
                  <li>Facebook, Instagram, LinkedIn</li>
                </ul>

                <div class="google">
                  <img
                    class="logoCoursera"
                    src={coursera}
                    alt="Logo Coursera"
                  />
                  <img class="logoGoogle" src={google} alt="Logo Google" />
                </div>
                <ul className="cv__list">
                  <li>UX Design Professional Certificate</li>
                </ul>

                {/* <img class="logoUdemy" src={udemy} alt="Logo Udemy" />
            <ul>
              <li>Complete React Developer 2021</li>
            </ul> */}
                <img class="logoUdemy" src={wesbos} alt="Logo Wes Bos" />
                <ul className="cv__list">
                  <li>Beginner JavaScript</li>
                  <li>ES6 for Everyone</li>
                  <li>React for Beginners</li>
                  <li>Getting Started: Advanced React and GraphQL</li>
                </ul>
              </section>
            </div>

            <div class="container__rightSide">
              <section class="aboutMe">
                <h2 className="cv__h2">About Me</h2>
                <p className="noMargin">
                  I enjoy learning new things and continuously improving my
                  knowledge and skills.
                </p>
              </section>
              <section class="work">
                <h2 className="cv__h2">Work Experience</h2>
                <h3 className="cv__h3">Robert Bosch | 2022 – present</h3>
                <ul className="cv__list">
                  <li>Full-stack software developer</li>
                </ul>

                <h3 className="cv__h3">Freelance | 2021 – present</h3>
                <ul className="cv__list">
                  <li>
                    {' '}
                    <strong>Czechitas</strong> – coach HTML/CSS, Figma, React
                  </li>
                  <li>Website development</li>
                </ul>
                <h3 className="cv__h3">Parental leave | 2017 – 2022</h3>
                <ul className="cv__list">
                  <li>Support at family guesthouse, managing grants</li>
                  <li>Accommodation services, bookkeeping</li>
                </ul>

                <h3 className="cv__h3">
                  Československá obchodní banka, a.s. | 2008 – 2017
                </h3>
                <ul className="cv__list">
                  <li>Loan specialist and client advisor</li>
                  <li>Mortgage and business financing</li>
                </ul>
              </section>

              <section class="education">
                <h2 className="cv__h2">Education</h2>
                <h3 className="cv__h3">
                  University of South Bohemia, Faculty of Economics | 2005 –
                  2010
                </h3>
                <ul className="cv__list">
                  <li>Study program Economics and Management, Ing. degree</li>
                  <li>Major: Business Management</li>
                </ul>
              </section>
            </div>
          </div>

          <div class="container">
            <div class="container__leftSide">
              <section class="languages">
                <h2 className="cv__h2">Languages</h2>
                <ul className="cv__list">
                  <li>English</li>
                  <li>German</li>
                  <li>French – very passive</li>
                </ul>
              </section>
            </div>
            <div class="container__rightSide">
              <section class="other">
                <h2 className="cv__h2">Other</h2>
                <ul className="cv__list">
                  <li>Microsoft Office proficiency</li>
                  <li>Driver's license category B, active driver</li>
                  <li>Independence, willingness to learn and self-improve</li>
                  <li>Presentation skills, professional conduct</li>
                  <li>Understanding of financial statements</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ComponentToPrint;
